import moment from 'moment-timezone';

export default {
  catPages: {},
  catPageIdList: [],
  pagination: {},
  selectedOptions: {},
  startTime: new Date(),
  currentDate: moment(new Date()).tz('Asia/Seoul').format('YYYYMMDD'),
  monitoringHistories: [],
  pageQuizResultCache: {},
  pageAnswerStatistics: [],
  useQuestions: {},
};
